import { DateTime, Duration } from 'luxon'
import * as logger from '@/utils/logger'
import { deepClone } from '@/utils/deepClone'
import trackingDevices from '@/services/trackingDevices'

export const state = {
  distanceAndDuration:
    JSON.parse(window.localStorage.getItem('distanceAndDuration')) || {},
  devicesByVehicleIds: {},
}

export const mutations = {
  DISTANCE_AND_DURATION(state, { key, value }) {
    state.distanceAndDuration = deepClone({
      ...state.distanceAndDuration,
      [key]: value,
    })

    // preserve state between page page refreshes
    saveState('distanceAndDuration', state.distanceAndDuration)
  },

  UPDATE_DEVICES_BY_VEHICLE_IDS(state, axiosResponse) {
    const devices = {}
    for (const tracker of axiosResponse.data.devices) {
      devices[tracker.vehicleId] = tracker
    }

    // Use deepClone to force Vue to react to the state change
    state.devicesByVehicleIds = deepClone({
      ...state.devicesByVehicleIds,
      ...devices,
    })
  },
}

export const getters = {
  distanceAndDuration: (state) => (vehicleId, addressId) => {
    return state.distanceAndDuration[`${vehicleId}-${addressId}`]
  },
  devicesByVehicleIds: (state) => (vehicleId) => {
    return state.devicesByVehicleIds[vehicleId]
  },
}

export const actions = {
  async getTrackingDevicesByVehicleIdsV2(store, params) {
    const { requestBody, prioritizeEld } = params
    const response = await trackingDevices.fetchTrackingDevicesByVehicleIdsV2(
      requestBody,
      prioritizeEld
    )
    store.commit('UPDATE_DEVICES_BY_VEHICLE_IDS', response)
    return response
  },
  async getTrackingDevicesByCompanyId(store, companyId) {
    const response = await trackingDevices.fetchTrackingDevicesByCompanyId(
      companyId
    )
    return response
  },
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
